

























import { Component, Vue } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';

@Component
export default class ContactUs extends Vue {
    public contactUsMessage: string = '';

    constructor() {
        super();
    }

    public sendContactUs() {
        if (this.contactUsMessage === '') {
            return false;
        }
        this.$store.dispatch(Actions.SEND_CONTACT_US, this.contactUsMessage);
    }

    public cancel() {
       this.$store.commit(Mutations.SET_CONTACT_US_VISIBILITY, false);
    }
}
